export default __webpack_public_path__ + "static/media/Stonex100Logo.f0a0b6c4.svg";